// src/pages/Register/Register.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Register.css';
import Button from '../../components/Button';
import LoadingIndicator from '../../components/LoadingIndicator';
import { getSocialLoginUrl } from '../../services/socialLoginService';

const Register: React.FC = () => {
  const [activeMethod, setActiveMethod] = useState<'email' | 'line'>('email');
  const [loading, setLoading] = useState(false);
  const [consent1, setConsent1] = useState(false);
  const [consent2, setConsent2] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('auth_token')) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleEmailClick = () => {
    window.dataLayer?.push({
      event: 'sign_up_click',
      method: 'email'
    });
    navigate('/register/email');
  };

  const handleLineRegister = () => {
    window.dataLayer?.push({
      event: 'sign_up_click',
      method: 'line'
    });
    setLoading(true);
    window.location.href = getSocialLoginUrl('line');
  };

  // 両方チェックが入っていて loading でなければ有効化
  const isLineEnabled = consent1 && consent2 && !loading;

  return (
    <div className="register-page">
      <h1 className="page-title">新規登録</h1>

      <div className="method-tabs">
        <button
          className={`tab ${activeMethod === 'email' ? 'active' : ''}`}
          onClick={() => setActiveMethod('email')}
        >
          メールで登録
        </button>
        <button
          className={`tab ${activeMethod === 'line' ? 'active' : ''}`}
          onClick={() => setActiveMethod('line')}
        >
          LINEで登録
        </button>
      </div>

      {loading && <LoadingIndicator isFullPage={false} />}

      {activeMethod === 'email' && (
        <div className="email-register-redirect">
          <p>
            メールアドレスで登録を行います。下記ボタンをクリックしてください。
          </p>
          <Button onClick={handleEmailClick} disabled={loading} width="100%">
            メールで登録ページへ
          </Button>
        </div>
      )}

      {activeMethod === 'line' && (
        <div className="line-register">
          <p>
            LINEアカウントで登録を行います。必要項目に同意のうえ、下記ボタンをクリックしてください。
          </p>

          <div className="consent-container">
            <label className="consent-item">
              <input
                type="checkbox"
                checked={consent1}
                onChange={(e) => setConsent1(e.target.checked)}
              />
              本アプリが取得するメールアドレスの利用目的を理解し、同意します。
            </label>
            <label className="consent-item">
              <input
                type="checkbox"
                checked={consent2}
                onChange={(e) => setConsent2(e.target.checked)}
              />
              LINEユーザーデータポリシーに定める取扱いを遵守します。
            </label>
            {/* 必要に応じてポリシー詳細へのリンクを追加 */}
            <p className="policy-link">
              <Link to="/privacy-policy">
                プライバシーポリシー・LINEポリシー詳細
              </Link>
            </p>
          </div>
          <Button
            onClick={handleLineRegister}
            disabled={!isLineEnabled}
            width="100%"
            bgColor={isLineEnabled ? '#00c300' : '#ccc'}
            textColor={isLineEnabled ? '#fff' : '#666'}
            className={isLineEnabled ? 'btn-enabled' : 'btn-disabled'}
          >
            {loading ? '処理中...' : 'LINEで登録する'}
          </Button>
        </div>
      )}

      <div className="auth-link">
        <p>
          既にアカウントをお持ちの場合は <Link to="/login">こちら</Link>
        </p>
        <p>
          パスワードをお忘れの場合は <Link to="/password-reset">こちら</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
